import {useEffect} from "react";
import moment from "moment";
import "url-search-params-polyfill";

// eslint-disable-next-line import/prefer-default-export
export function useWindowTitle(title) {
    useEffect(
        () => {
            window.document.title = title;
        },
        [title],
    );

    return title;
}

export function distanceFormattedDate(rawDate) {
    return moment(rawDate).fromNow();
}

export function getBuddyPosition(queryString = window.location.search) {
    const searchParams = new URLSearchParams(queryString);
    return searchParams.get("buddyPosition");
}
